import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
// @ts-ignore
// import ComponentInspector from '@brianball/component-inspector';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 3,
    },
  },
});

// Initialize Component Inspector
// Always enabled for now - you can add conditions later
// const inspector = ComponentInspector.getInstance({
//   autoStart: true,
//   enableScreenshots: true,
//   enableRecording: true,
//   position: 'bottom-right', // Bottom right to avoid overlapping with admin nav
//   hotkeys: {
//     toggle: 'ctrl+shift+i',
//     screenshot: 'ctrl+shift+s',
//     record: 'ctrl+shift+r'
//   }
// });

// Make available globally for debugging
// (window as any).inspector = inspector;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
